export const abortXhr = (request) => {
    if ([0, 1, 2, 3].includes(request.readyState)) {
        request.abort();
    }
};
